// extracted by mini-css-extract-plugin
export default {"gap-1":"PSgJY","gap-2":"GlF7f","gap-3":"jj75a","gap-4":"QoMwI","gap-5":"b728x","gap-6":"Csi47","gap-7":"oDbI3","gap-8":"E_pvU"};